<script>
import { mapFields } from 'vuex-map-fields'
import { mapGetters } from 'vuex'

import AllModels from '@/models'
import { Model } from '@vuex-orm/core'
import _isEqual from 'lodash/isEqual'
import _get from 'lodash/get'
import { perPageValues } from '@/constants/PaginationDefaults'
import { parseSortBy } from '@/utils/parseSortVals'
export default {
  name: 'WithTableData',
  props: {
    Model: {
      type: Model,
      default: () => Model,
    },
  },
  data() {
    return {
      loading: false,
      error: null,
      localMeta: {},
      localItems: [],
      defaultTableConfig: {
        addable: true,
      },
      defaultPerPageValue: perPageValues[1],
    }
  },
  methods: {
    async fetch(page = null) {
      this.loading = true
      let queryPage = Number(_get(this.$route, 'query.page', 1))
      let querySearch = _get(this.$route, 'query.q', false)
      let sortColumn = _get(this.$route, 'query.sort', false)
      let filters = _get(this.$route, 'query.filters', false)

      try {
        let options = {
          page: page || queryPage,
          per_page:
            _get(this.$route, 'query.per_page') || this.defaultPerPageValue,
          ...(!!querySearch && { q: querySearch }),
          ...(!!sortColumn && { sort: sortColumn }),
          ...(!!filters && { filters }),
        }

        this.tableFetchOptions = options

        let { response } = await this.Model.fetchForShop(options)

        this.localItems = _get(response, 'data.data', {})
        this.localMeta = _get(response, 'data.meta', {})

        // if no items are returned
        if (!this.localItems.length) {
          // and we're not on page 1
          if (queryPage > 1) {
            // and the last_page of results is less than the current page
            if (Number(this.localMeta.last_page) < queryPage) {
              // fetch the last_page of results recursively
              await this.fetch(Number(this.localMeta.last_page))
            }
          }
        }
        await this.updateMetaData()
        this.isTableStale = false
      } catch (error) {
        this.error = error
        throw Error(error)
      } finally {
        this.loading = false
      }
    }, // fetch
    updateMetaData() {
      this.tableItems = this.localItems
      this.currentPage = Number(this.localMeta.current_page)
      this.pageCount = Number(this.localMeta.last_page)
      this.itemsPerPage = Number(this.localMeta.per_page)
      this.totalItems = Number(this.localMeta.total)
      this.from = Number(this.localMeta.from)
      this.to = Number(this.localMeta.to)
      this.sortBy = parseSortBy(this.localMeta.sortBy)
    }, // updateMetaData
  }, // methods
  computed: {
    ...mapGetters('shop', ['getEnableItemDates']),
    ...mapFields('admin', [
      'tableConfig',
      'tableItems',
      'isTableStale',
      'tableFetchOptions',
    ]),
    ...mapFields('admin', {
      currentPage: 'tableMeta.page',
      pageCount: 'tableMeta.last_page',
      itemsPerPage: 'tableMeta.per_page',
      totalItems: 'tableMeta.total',
      from: 'tableMeta.from',
      to: 'tableMeta.to',
      sortBy: 'tableMeta.sortBy',
    }),
    headers() {
      let headers = this.Model.field_headers
        ? this.Model.field_headers().filter(
            (h) => !_get(h, 'hideOnIndex', false)
          )
        : []

      if (
        this.Model.namePlural === AllModels.ItemModel.namePlural &&
        !this.getEnableItemDates
      ) {
        // If we're building the ItemModel headers and ITEM_DATES flag is disabled,
        // remove the date column if it exists
        headers = headers.filter((h) => _get(h, 'value') !== 'date')
      }
      const expandRecordField = {
        text: '',
        align: 'center',
        value: 'expand',
        sortable: false,
        width: 20,
      }
      headers.unshift(expandRecordField)
      return headers
    }, // headers
  },
  watch: {
    '$route.query': {
      async handler(newQuery, oldQuery) {
        if (_isEqual(newQuery, oldQuery)) return
        if (Object.keys(newQuery).length) {
          this.currentPage = Number(newQuery.page) || 1
          this.itemsPerPage =
            Number(newQuery.per_page) || this.defaultPerPageValue
        }
        await this.fetch()
      },
      immediate: true,
    },
    isTableStale(val) {
      if (val) {
        this.fetch()
      }
    },
  },
  created() {
    this.tableConfig = this.Model.index_table_config
      ? { ...this.defaultTableConfig, ...this.Model.index_table_config() }
      : this.defaultTableConfig
  },
  render() {
    return this.$scopedSlots.default({
      headers: this.headers,
      loading: this.loading,
      error: this.error,
    })
  },
}
</script>
